import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";

export const fetchHomeSliders = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-slider?sort=sort_order:asc`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchTilesHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-info-tile-header`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeTiles = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-info-tile?sort=sort_order:asc`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeAbout = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-about`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchHomeMessage = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-chairman-s-message?sort=sort_order:desc`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchChooseUs = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-why-choose-us`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

// export const fetchHomeHighlights = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-highlights`,
//       { headers: cmsHeaders },
//     );
//     return response.data.slice(-1);
//   } catch (error) {
//     console.error("Server Error");
//   }
// };

export const fetchHomeHighlights = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/home-highlights`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

// export const fetchHomeCount = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_strapiUrl}/api/ega-home-count-sections?populate=*`,
//       { headers },
//     );
//     return response.data.data.slice(-1);
//   } catch (error) {
//     console.error("Server Error");
//   }
// };

// export const fetchHomeFacultyHeader = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_strapiUrl}/api/ega-home-faculty-headers?populate=*`,
//       { headers },
//     );
//     return response.data.data.slice(-1);
//   } catch (error) {
//     console.error("Server Error");
//   }
// };

// export const fetchHomeFacultyList = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_strapiUrl}/api/ega-home-faculty-lists?populate=*`,
//       { headers },
//     );
//     return response.data.data;
//   } catch (error) {
//     console.error("Server Error");
//   }
// };

// export const fetchHomeTestimonialHeader = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_strapiUrl}/api/ega-home-testimonial-headers?populate=*`,
//       { headers },
//     );
//     return response.data.data.slice(-1);
//   } catch (error) {
//     console.error("Server Error");
//   }
// };

// export const fetchHomeTestimonial = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_strapiUrl}/api/ega-home-testimonials?populate=*`,
//       { headers },
//     );
//     return response.data.data;
//   } catch (error) {
//     console.error("Server Error");
//   }
// };
